module.exports = __webpack_public_path__ + "img/77297.fc976529.svg";